import React from 'react';
import './index.scss';


//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';


//custom component

//api
import {api} from '../../../../functions/api';

//other libraries
import { inject, observer } from 'mobx-react';
import {toJS} from 'mobx';





@inject('translate')
@inject('internal')
@observer
export default class AddCategoryOrTag extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedObjects: [],
            values: [this.props.categories],
            valuesTags: [this.props.tags],
            selectedTags: [],
            selectedTagsNames: [],
            checkedRows: toJS(this.props.internal.checkedRows)
        }
    }

    componentDidMount() {

    }

    handleChange = (event) => {
        if(event.target.value !== "") {
            let values = this.state.values;
            values.splice(event.target.value.level+1);
            let selectedObj = this.state.selectedObjects
            selectedObj.splice(event.target.value.level);
            selectedObj.push(event.target.value)
            this.setState({selectedObjects: selectedObj})

            if(event.target.value.children.length) {
                values.push(event.target.value.children)
                this.setState({values: values})
            }
        }
        else {
            let values = this.state.values;
            let selectedObj = this.state.selectedObjects
            if(values.length === selectedObj.length) {
                selectedObj.splice(selectedObj.length-1)
                this.setState({selectedObjects: selectedObj})
            }
        }

    }

    handleChangeTag = (event) => {

        this.setState({selectedTags: event.target.value})
    }

    action = async () => {

        if(this.state.selectedObjects.length || this.state.selectedTags.length) {
        if(this.props.dialogType === "tag") {
            let productsId = toJS(this.props.internal.checkedRows)
                let update_data = await api({
                    method: 'patch',
                    url: `products/pair-tags`,
                    authorization: this.props.internal.user.access_token,
                    params: {
                        tags: this.state.selectedTags,
                        products: productsId
                    }
                })
                if(update_data.success === true) {
                    this.props.internal.setSnackbar(update_data.data.message, true)
                    this.props.closeDialog(true)
                }

        }

        else if(this.props.dialogType === "category") {
            let update_data = await api({
                method: 'patch',
                url: 'products/pair-category',
                authorization: this.props.internal.user.access_token,
                params: {
                    category: this.state.selectedObjects[this.state.selectedObjects.length - 1].id,
                    products: this.state.checkedRows
                }
            })
            if(update_data.success === true) {
                // this.props.showSnackbar(update_data.data.message, true, true)
                this.props.internal.setSnackbar(update_data.data.message, true)
                this.props.closeDialog(true)
            }
        }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOTHING_CHOOSEN, true)
        }



    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"

            >
                <DialogTitle id="form-dialog-title">{this.props.dialogType === 'tag' ? this.props.translate.i18n.MODULES.PRODUCTS.EDIT_TAG: this.props.translate.i18n.MODULES.PRODUCTS.EDIT_CATEGORY}</DialogTitle>
                <DialogContent className={'categorise-dialog'}>

                    {this.props.dialogType === 'category' ?
                        this.state.values.map((options, index) => {return (
                            <React.Fragment key={index}>
                            <FormControl className='tags-selector'>
                                {index === 0 ? <InputLabel htmlFor={`category-${index}`} className={'label-select-tag'}>{this.props.translate.i18n.MODULES.PRODUCTS.CHOOSE_CATEGORY}</InputLabel> : null }
                                <Select
                                    className={'select-category'}
                                    value={this.state.selectedObjects[index] ? this.state.selectedObjects[index].name : ""}
                                    onChange={this.handleChange}
                                    renderValue={() => {return (<span>{this.state.selectedObjects[index].name}</span>)}}
                                    // inputProps={{
                                    //     name: 'category',
                                    //     id: `category-${index}`,
                                    // }}

                                    // displayEmpty={true}
                                    >
                                    {
                                        index > 0 ? <MenuItem key="0" value="">{this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY_NONE}</MenuItem> : null
                                    }
                                    {
                                        options.map((option, optionIndex) => {
                                            return (
                                                <MenuItem key={optionIndex} value={option}>{option.name}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                </FormControl>
                            </React.Fragment>
                        )})
                        :
                        <React.Fragment>
                            <FormControl className='tags-selector'>
                                <InputLabel className={'label-select-tag'}>{this.props.translate.i18n.MODULES.PRODUCTS.CHOOSE_TAG}</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.selectedTags}
                                    onChange={this.handleChangeTag}
                                    input={<Input id="select-multiple" />}
                                >
                                    {
                                        this.props.tags.map((option, optionIndex) => {
                                            return (
                                                <MenuItem key={optionIndex} value={option.id}>{option.title}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </React.Fragment>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <Button onClick={this.action} className={'orange-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button>
                </DialogActions>

            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/list/addCategoryTag/index.js